// utils/toast.js
import { toast } from "react-toastify";

export const formatDataNumberToen = (number = 0) => {
  return number?.toLocaleString("en-US");
};


const defaultOptions = {
  position: "top-center",
  autoClose: 3000,
  // Option của từng toast thắng prop hideProgressBar của ToastContainer, nên
  // phải tắt ở đây nữa mới thật sự ẩn được thanh progress.
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  theme: "light",
};

export const Toast = {
  success(message = "Thành công", options = {}) {
    toast.success(message, {
      ...defaultOptions,
      ...options,
    });
  },

  error(message = "Có lỗi xảy ra", options = {}) {
    toast.error(message, {
      ...defaultOptions,
      ...options,
    });
  },

  info(message, options = {}) {
    toast.info(message, {
      ...defaultOptions,
      ...options,
    });
  },

  warning(message, options = {}) {
    toast.warning(message, {
      ...defaultOptions,
      ...options,
    });
  },

  loading(message = "Đang xử lý...") {
    return toast.loading(message, defaultOptions);
  },

  updateSuccess(id, message = "Thành công") {
    toast.update(id, {
      render: message,
      type: "success",
      isLoading: false,
      autoClose: 3000,
    });
  },

  updateError(id, message = "Có lỗi xảy ra") {
    toast.update(id, {
      render: message,
      type: "error",
      isLoading: false,
      autoClose: 3000,
    });
  },

  async promise(
    promise,
    {
      pending = "Đang xử lý...",
      success = "Thành công",
      error = "Có lỗi xảy ra",
    } = {}
  ) {
    return toast.promise(
      promise,
      {
        pending,
        success,
        error: {
          render({ data }) {
            return data?.message || error;
          },
        },
      },
      defaultOptions
    );
  },
};

export const getIsdnNoNationalCode = (msisdn) => {
  let msisdnNoNationalCode = "";
  if (msisdn) {
    msisdnNoNationalCode = msisdn.replace("+", "");
    const countryCode = "95";
    const nationalPrefix = "0";
    const internationalPrefix = "00";
    if (msisdnNoNationalCode.startsWith(countryCode)) {
      msisdnNoNationalCode = msisdnNoNationalCode.slice(countryCode.length);
    } else if (msisdnNoNationalCode.startsWith(nationalPrefix)) {
      msisdnNoNationalCode = msisdnNoNationalCode.slice(nationalPrefix.length);
    } else if (msisdnNoNationalCode.startsWith(internationalPrefix)) {
      msisdnNoNationalCode = msisdnNoNationalCode.slice(
        internationalPrefix.length
      );
    }
  }
  return msisdnNoNationalCode;
};